var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrowPurple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6704 14.5016C17.4592 14.2971 17.1729 14.1822 16.8744 14.1822C16.5758 14.1822 16.2895 14.2971 16.0784 14.5016L10.1191 20.2758V1.09092C10.1191 0.80159 10.0005 0.52411 9.78932 0.319523C9.57818 0.114936 9.29181 0 8.9932 0C8.6946 0 8.40823 0.114936 8.19709 0.319523C7.98594 0.52411 7.86732 0.80159 7.86732 1.09092V20.2758L1.90804 14.5016C1.6957 14.3029 1.4113 14.1929 1.1161 14.1954C0.820895 14.1979 0.53851 14.3126 0.329763 14.5149C0.121016 14.7172 0.00260779 14.9908 4.2561e-05 15.2768C-0.00252267 15.5628 0.11096 15.8384 0.316048 16.0442L8.19721 23.6806C8.40834 23.8851 8.69466 24 8.9932 24C9.29175 24 9.57807 23.8851 9.7892 23.6806L17.6704 16.0442C17.8814 15.8396 18 15.5621 18 15.2729C18 14.9836 17.8814 14.7062 17.6704 14.5016Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrowPurple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/downArrowPurple.5704740e2a2988b3b21d698d58634553.svg";